export default function (currentUser, userInRole) {
    return function (item) {
        return currentUser()
            .then(result => {
                if (!result || !result.roles) {
                    return false;
                }

                if (!item || !item.roles) {
                    return false;
                }

                return userInRole.verify(result.roles, item.roles);
            });
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/services/securityConfig.js